import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  announcement: "",
};

const announcementSlice = createSlice({
  name: "announcement",
  initialState: initialState,
  reducers: {
    // setannouncement(state, payload) {
    //     console.log(payload.payload.response);
    //     state.announcement = payload.payload.response;
    // },
    getAnnouncements(state, payload) {
        // console.log(payload.payload.response);
        state.announcement = payload.payload.response;
    },
    alert(state, action) {
        state.error = action.payload;
      },
  },
});

export default announcementSlice.reducer;
export const announcementActions = announcementSlice.actions;
